import React from "react";
import "./NewsletterSection.css";

// Import required components
import { Heading, Newsletter } from "../../../components";



const NewsletterSection = () => {
  return (
    <section className="newsletter-subscribe">
      <div className="content">

        <div className="intro">
          <Heading title={"Subscribe To Our Newsletter"} linear sideHeading /> {/* Section heading with linear style */}
          <p>Stay informed with the latest updates.</p>
        </div>
        
          <Newsletter variant='default' idPrefix='1' /> {/* Newsletter subscription form */}
      
      </div>
    </section>
  );
};

export default NewsletterSection;